import React from "react";
import { Row, Col, Container } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
              <footer className="footer">
                  <Container fluid>
                        <Row>
                            <Col sm={12}>
                                <div className="text-sm-left">
                                {new Date().getFullYear()} © Absolin.
                                </div>
                            </Col>
                            
                        </Row>
                  </Container>
              </footer>
    </React.Fragment>
  );
};

export default Footer;
